const get = require('lodash/get')
const { listProductsForPrograms } = require('./list-for-programs-services')
const {
  buildServiceColumns,
  getServiceIdsFromConfigurationDocs
} = require('./../../tools')
const utils = require('./../../utils')

exports.exportProducts = async (state, opts = {}) => {
  const userPrograms = get(state, 'user.programs', [])
  const products = await listProductsForPrograms(state, userPrograms)
  const serviceIds = await getServiceIdsForPrograms(state, userPrograms)
  const serviceColumns = buildServiceColumns(serviceIds)
  const additionalColumns = Object.assign(
    {},
    get(opts, 'additionalColumns', {}),
    serviceColumns
  )
  return utils.sheet.encode(products, Object.assign({}, opts, { additionalColumns }))
}

async function getServiceIdsForPrograms (state, programIds) {
  const serviceConfigurationsByProgram = await Promise.all(
    (programIds || []).map(programId => state.dal.product.getProgramConfiguration(state, programId))
  )
  const serviceConfigurations = serviceConfigurationsByProgram
    .reduce((acc, docs) => acc.concat(docs), [])

  return getServiceIdsFromConfigurationDocs(serviceConfigurations)
}
